import { cn } from "@/lib/utils";

type ProductImagePlaceholderProps = {
  className?: string;
  aspectRatio?: string;
};

export function ProductImagePlaceholder({ 
  className,
  aspectRatio = "aspect-square"
}: ProductImagePlaceholderProps) {
  return (
    <div 
      className={cn(
        "relative overflow-hidden rounded-xl bg-gradient-to-br from-[#0b111a] to-[#0e1824] flex items-center justify-center",
        "border border-[#5BFF9A]/20 shadow-[0_0_20px_rgba(91,255,154,0.15)]",
        aspectRatio,
        className
      )}
    >
      <div className="text-center px-4">
        <p className="text-[#9fffe0] font-medium text-base md:text-lg opacity-88">
          Image Coming Soon...
        </p>
      </div>
    </div>
  );
}
